import TrainingProvider from "../../model/TrainingProvider";
import { ApiResponse } from "../CustomFetch";
import { api } from "./BaseApi";

const trainingProviderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllTrainingProviders: builder.query<TrainingProvider[], void>({
      query: () => "/TrainingProvider",
      transformResponse: (response: ApiResponse<TrainingProviderRaw[]>) =>
        response.data.map(
          (d) =>
            ({
              key: d.key,
              label: {
                de: d.labelDE,
                en: d.labelEN,
                fr: d.labelFR,
                it: d.labelIT,
              },
            } as TrainingProvider)
        ),
    }),
  }),
});

export const { useGetAllTrainingProvidersQuery } = trainingProviderApi;

interface TrainingProviderRaw {
  key: string;
  labelDE: string;
  labelEN: string;
  labelFR: string;
  labelIT: string;
}
